import React from "react";
import { Button, Icon } from "../Component";

function AdminToolbarToggle({ open, onToggle, ariaLabel = "Toggle tools" }) {
  return (
    <div className="toggle-wrap nk-block-tools-toggle">
      <Button
        type="button"
        className={`btn-icon btn-trigger toggle-expand mr-n1 ${open ? "active" : ""}`}
        onClick={onToggle}
        aria-expanded={open}
        aria-label={ariaLabel}
      >
        <Icon name="menu-alt-r" />
      </Button>
    </div>
  );
}

export default AdminToolbarToggle;
